import { Box, createStyles, Group, Stack } from '@mantine/core';
import type { LineageFlowTest } from '@repo/api-codegen';
import { EntityType } from '@repo/common/enums/entityType';
import { titleCase } from '@repo/common/utils';
import { Badge, Text } from '@repo/foundations';
import { EntityIcon } from '../EntityIcon/EntityIcon';

interface TestItemProps {
	test: LineageFlowTest;
}

const useStyles = createStyles((theme) => ({
	container: {
		padding: `${theme.spacing.sm} ${theme.spacing.md}`,
	},
}));

function TestItem({ test }: TestItemProps) {
	const { classes } = useStyles();

	return (
		<Box className={classes.container}>
			<Group w="100%" position="apart">
				<Group noWrap>
					<EntityIcon
						entityType={EntityType.test}
						integrationType={test.integration_type ?? undefined}
					/>
					<Stack spacing={0}>
						<Text size="sm" weight="semibold">
							{test.title}
						</Text>
						<Text size="xs" color="text/secondary/default">
							{test.suite_title}
						</Text>
					</Stack>
				</Group>
				{test.latest_run && (
					<Badge variant={test.latest_run?.success ? 'success' : 'critical'}>
						{titleCase(test.latest_run?.status)}
					</Badge>
				)}
			</Group>
		</Box>
	);
}

export default TestItem;
